import { useCallback, useEffect, useState } from "react";
import { PaginationRequest } from "../Types/Pagination";

export function usePaginationRequestHook(
  page?: number,
  pageSize?: number,
  search?: string,
  sortBy?: string,
  sortAscending?: boolean
) {
  const [paginationRequest, setPaginationRequest] = useState<PaginationRequest>({
    page: 0,
    pageSize: 10,
    search: "",
    sortBy: "",
    sortAscending: true,
  });

  const generatePaginationRequest = useCallback(() => {
    setPaginationRequest((previousRequest) => ({
      ...previousRequest,
      page: page ?? previousRequest.page,
      pageSize: pageSize ?? previousRequest.pageSize,
      sortBy: sortBy ?? previousRequest.sortBy,
      sortAscending: sortAscending ?? previousRequest.sortAscending,
    }));
  }, [page, pageSize, sortBy, sortAscending]);

  useEffect(() => {
    generatePaginationRequest();
  }, [page, pageSize, sortBy, generatePaginationRequest]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setPaginationRequest((previousRequest) => ({
        ...previousRequest,
        page: 0,
        search: search ?? previousRequest.search,
      }));
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [search]);

  return [paginationRequest] as const;
}
